/* global rwgps, google */
import React from 'react'
import _ from 'lodash'

export class GooglePolyline extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = this.sliceOnSurface(props.positions)
  }

  sliceOnSurface = positions => {
    if (!rwgps.surfaces?.surfaceGroups || !_.some(positions, p => p.surface)) {
      return {
        slices: [[null, 0]] // just set it to something that won't trigger surfacePolyline call
      }
    }
    let tp
    let thisTpSurfaceGroup
    let lastTpSurfaceGroup = rwgps.surfaces.surfaceGroups[positions[0].surface]
    const surfaceIndices = []
    for (let i = 0; i < positions.length; i++) {
      tp = positions[i]
      tp.i = this
      tp.segment = this
      // SURFACE: add to surfaceIndices when last tp is in a different group than this tp
      if (i > 1) {
        thisTpSurfaceGroup = rwgps.surfaces.surfaceGroups[tp.surface]
        if (lastTpSurfaceGroup !== thisTpSurfaceGroup) {
          lastTpSurfaceGroup = thisTpSurfaceGroup
          surfaceIndices.push(i - 1)
        }
      }
    }

    const slices = []
    if (positions.length > 0 && positions[0]) {
      // SURFACE: slice positions on surface change boundaries so we can render multiple polylines
      // NOTE: we add a ll for the prevControlPoint
      if (surfaceIndices.length > 0) {
        let lastSIdx = 0
        surfaceIndices.forEach(sIdx => {
          slices.push([positions.slice(lastSIdx, sIdx + 1), positions[sIdx].surface])
          lastSIdx = sIdx
        })
        slices.push([positions.slice(lastSIdx), positions[positions.length - 1].surface])
      } else {
        slices.push([positions, positions[positions.length - 1].surface])
      }
    }

    return {
      slices
    }
  }

  componentDidMount () {
    this.addToMap()
  }

  addToMap = () => {
    const { mapInstance, positions, color, weight } = this.props
    const { slices } = this.state

    this._polyline = new google.maps.Polyline({
      path: positions,
      // if mapInstance isn't a rwgps.Map, assume it's a direct reference to the gmap
      map: mapInstance.gmap || mapInstance,
      strokeColor: color,
      strokeWeight: weight,
      zIndex: 0
    })

    this._polylines = []
    slices.forEach(([llSlice, surface]) => {
      const sliceSurface = rwgps.surfaces.surfaceGroups[`${surface}`]

      if (sliceSurface !== 'paved') {
        this.surfacePolyline(llSlice, sliceSurface, mapInstance.map || mapInstance)
      }
    })
  }

  // even though we have no sticky pref for st for now, we need to account for
  // 1. mapbox overlay, 2. uncheck surface, 3. swap to google overlay
  surfacePolyline = (lls, surface, map) => {
    const { showSurface, weight } = this.props
    if (surface === 'unpaved') {
      this._polylines.push(new google.maps.Polyline({
        map: showSurface ? map : null,
        strokeOpacity: 0,
        zIndex: 2,
        path: lls,
        clickable: false,
        icons: [{
          icon: {
            path: 'M 0,-1 0,1',
            strokeOpacity: 1,
            strokeColor: '#FFFFFF',
            strokeWeight: weight
          },
          offset: '0',
          repeat: '16px'
        }]
      }))
    } else {
      this._polylines.push(new google.maps.Polyline({
        map: showSurface ? map : null,
        strokeOpacity: 1,
        strokeWeight: rwgps.Route.DEFAULT_LINE_WIDTH / 2,
        strokeColor: '#FFFFFF',
        zIndex: 2,
        path: lls,
        clickable: false
      }))
    }
  }

  componentDidUpdate (prevProps) {
    const { positions, mapInstance, showSurface } = this.props
    if (prevProps.positions.length !== positions.length) {
      this._polyline.setMap(null)
      delete this._polyline
      this._polylines.forEach(p => p.setMap(null))
      delete this._polylines
      this.setState(this.sliceOnSurface(positions), () => {
        this.addToMap()
      })
    }

    if (prevProps.showSurface !== showSurface) {
      this._polylines.forEach(p => p.setMap(showSurface ? mapInstance || mapInstance.map : null))
    }
  }

  componentWillUnmount () {
    this._polyline.setMap(null)
    this._polylines.forEach(p => p.setMap(null))
    delete this._polyline
    delete this._polylines
  }

  render () {
    return (
      null
    )
  }
}
